<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-form
                        ref="processIssueForm"
                >
                <h3 class="mb-3">{{$vuetify.lang.t('$vuetify.process_issue.title')}}</h3>
                <v-select
                            v-model="selected_issue_type_data"
                            :items="isssue_types"
                            item-value="value"
                            item-text="display_value"
                            :label="$vuetify.lang.t('$vuetify.process_issue.placeholders.issue_type_select')"
                            :disabled="formDisabled"
                            return-object
                            @change="detailsCheck"
                    ></v-select>
                    <v-select
                            v-if="failure_details_list"
                            v-model="RPISIssueTypeDetail"
                            :items="failure_details_list"
                            item-vaule="value"
                            item-text="display_value"
                            :label="$vuetify.lang.t('$vuetify.process_issue.placeholders.failure_detail')"
                            :disabled="formDisabled"
                    ></v-select>
                    <v-text-field
                            v-model="RPISWho"
                            :counter="RPISWhoMaxLength"
                            :label="$vuetify.lang.t('$vuetify.process_issue.placeholders.who')"
                            required
                            :disabled="formDisabled"
                            :rules="whoRules"
                    ></v-text-field>
                    <v-textarea
                            v-model="RPISDescription"
                            no-resize
                            rows="4"
                            ref="inputOepsWhat"
                            :label="$vuetify.lang.t('$vuetify.process_issue.placeholders.description')"
                            :disabled="formDisabled"
                            :rules="generalInputRules"
                    ></v-textarea>
                    <v-checkbox v-if="appSettings.processIssueUsesCNF" v-model="CNF_Checkbox"
                    :label="$vuetify.lang.t('$vuetify.process_issue.placeholders.cnf')"
                    :disabled="formDisabled"
                    ></v-checkbox>
                    <v-textarea
                            v-model="RPISComment"
                            no-resize
                            rows="4"
                            ref="inputOepsWhat"
                            :label="$vuetify.lang.t('$vuetify.process_issue.placeholders.comment')"
                            :disabled="formDisabled"
                            :rules="commentRules"
                    ></v-textarea>
                    <div class="text-center text-md-left mt-6">
                        <v-btn class="white--text" color="primary" :disabled="isFilled" @click="doLocationCheck">{{$vuetify.lang.t('$vuetify.global.confirmAndSend')}}</v-btn>
                    </div>
                </v-form>
            </v-col>
        </v-row>
        <crit-err :shown="has_crit_error" :title="$vuetify.lang.t('$vuetify.errors.missing_critical_resource_title')" code="CE-RPI-01" :is_cancelable="true">
                {{$vuetify.lang.t('$vuetify.errors.missing_critical_resource')}}
            </crit-err>
        <locationPopup :is-visible="showPrivateLocationPopup" @checkComplete="save"></locationPopup>
    </v-container>
</template>
<script>
import CriticalAppErrorComponent from "../global/criticalAppError/CriticalAppErrorComponent";
import { AppBoundDataStorageHelper } from "@/helpers/LocalStorageHelpers/AppBoundDataStorageHelper"
import PrivateLocationCheckComponent from "../global/privateLocationChecker/PrivateLocationCheckComponent";
import axios from "axios";
import {CryptoHelper} from "../../../classes/CryptoHelper";
import {DateTimeHelper} from '../../../helpers/dateTime/DateTimeHelper'
import {ENTRY_DATA_KEY, LMRADataObjectHelper} from "@/api/repository/helpers/LMRADataObjectHelper";
import lmraDataRepositoryApi from "@/api/repository/lmraDataRepositoryApi";
import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";
import appSettings from "@/mixins/config/appSettings";

export const PIOTHERVALUE = 'OTHER';
export const PIS_StorageKey = 'LAST_PROCESS_ISSUE_DATA';

export default {
  name: "ReportProcessIssueComponent",
  data: () => {
    return {
      has_crit_error: false,
      formDisabled: false,
      CNF_Checkbox: false,
      selected_issue_type_data: null,
      failure_details_list: null,
      isssue_types: [],
      RPISWho: "",
      RPISDescription: "",
      RPISComment: "",
      RPISIssueType : '',
      RPISIssueTypeDetail: null,
      RPISWhoMaxLength: 200,
      inputMinLength: 4,
      whoInputMinLength: 2,
      commentInputMinLength : 2,
      commentInputMaxLength : 200,
      showPrivateLocationPopup: false
    };
  },
  components: {
    critErr: CriticalAppErrorComponent,
    locationPopup: PrivateLocationCheckComponent
  },
  methods: {
    doLocationCheck() {
      this.showPrivateLocationPopup = true;
    },
    save_process_issues_data(data){
        let raw_data = [];
        if (data !== undefined && Array.isArray(data)) {
            for (let index in data) {
                let issue_item = data[index];
                if (this.is_valid_failure_type_item(issue_item)) {
                    raw_data.push(issue_item);
                }
            }
        }
        if(raw_data.length >= 0){
            AppBoundDataStorageHelper.storeAppBoundDataForKey(PIS_StorageKey, raw_data);
        }
    },
    load_local_process_issue_data(){
        try {
            let data = AppBoundDataStorageHelper.getAppBoundDataForKey(PIS_StorageKey);
            this.build_process_issues_data(data);
        } catch (error) {
            this.has_crit_error = true;
        }
    },
    build_process_issues_data(data) {
      let data_for_select = this.prepare_localized_process_issue_data(data);
      if(data_for_select.length <= 0){
        this.has_crit_error = true;
      }else{
        this.isssue_types = data_for_select;
      }
    },
    create_other_option(){
        return {
            value : PIOTHERVALUE,
            display_value : this.$vuetify.lang.t("$vuetify.process_issue.placeholders.other")
        }
    },
    prepare_localized_process_issue_data(data) {
      let current_lang = this.$vuetify.lang.current;
      let localized_data = [];
      
      if (data !== undefined && Array.isArray(data)) {
        for (let index in data) {
          let issue_item = data[index];
          
          if (this.is_valid_failure_type_item(issue_item)) {
            let new_issue_item = {};
            new_issue_item["value"] = issue_item.failure_type;
            new_issue_item["display_value"] = issue_item.display_values["en"];

            if (issue_item.display_values[current_lang]) {
              new_issue_item["display_value"] = issue_item.display_values[current_lang];
            }

            let details = issue_item.failure_details;
            if (details !== undefined && Array.isArray(details)) {
              let new_details_array = [];
              
              for (let det_idx in details) {
                let detail = details[det_idx];
                if (this.is_valid_failure_detail_item(detail)) {
                  let new_detail_item = {};
                  new_detail_item["value"] = detail.value;
                  new_detail_item["display_value"] = detail.display_values["en"];

                  if (detail.display_values[current_lang]) {
                    new_detail_item["display_value"] = detail.display_values[current_lang];
                  }

                  new_details_array.push(new_detail_item);
                }
              }

              if (new_details_array.length > 0) {
                new_details_array.push(this.create_other_option());  
                new_issue_item["failure_details"] = new_details_array;
              }
            }
            
            localized_data.push(new_issue_item);
          }
        }
      }

      if(localized_data.length >= 0){
          localized_data.push(this.create_other_option())
      }
      
      return localized_data;
    },
    is_valid_failure_type_item(item) {
      if (
        item.failure_type !== undefined &&
        item.display_values !== undefined
      ) {
        return true;
      }
      return false;
    },
    is_valid_failure_detail_item(item) {
      if (item.value !== undefined && item.display_values !== undefined) {
        return true;
      }
      return false;
    },
    detailsCheck() {
        //reset details ...
        this.RPISIssueType = this.selected_issue_type_data.value;
        this.RPISIssueTypeDetail = null;

        if(this.selected_issue_type_data.failure_details !== undefined && this.selected_issue_type_data.failure_details.length > 0){
            this.failure_details_list = this.selected_issue_type_data.failure_details;
        }else{
            this.failure_details_list = null;
        }
        
    },
      async save(){
        


        this.formDisabled = true;
        this.showPrivateLocationPopup = false;

        let checked_RPISIssueTypeDetail = (this.RPISIssueTypeDetail === null) ? 'N/A' : this.RPISIssueTypeDetail;
        //let issue_id = this.generateIssueId(checked_RPISIssueTypeDetail);

        let dataObject  = await LMRADataObjectHelper.buildBaseLmraDataObject();
        dataObject[ENTRY_DATA_KEY]['who'] = this.RPISWho;
        dataObject[ENTRY_DATA_KEY]['description'] = this.RPISDescription;
        dataObject[ENTRY_DATA_KEY]['comments'] = this.RPISComment;
        dataObject[ENTRY_DATA_KEY]['cnf_checked'] = (this.CNF_Checkbox)? 1 : 0;
        dataObject[ENTRY_DATA_KEY]['type'] = this.RPISIssueType;
        dataObject[ENTRY_DATA_KEY]['detail'] = checked_RPISIssueTypeDetail;


          /* START SENDING PART */
        await lmraDataRepositoryApi.reportProcessIssue(dataObject).then(
            response => {
              window.console.log('RESPONSE : ')
              window.console.log(response);
              let message = this.$vuetify.lang.t('$vuetify.global.post_success');
              if(response.data.message !== undefined){
                message = response.data.message;
              }
              sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(message)
              this.$router.replace('/');
            }
        ).catch(error =>{
          window.console.log('ERROR');
          window.console.log(error);
          sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(this.$vuetify.lang.t('$vuetify.errors.data_save_failed') + ' err: ' + error.message);
          this.formDisabled = false;
        });
          /* END SENDING PART */

    },
      generateIssueId(checked_RPISIssueTypeDetail){
          let crypto = new CryptoHelper();
          let raw_issue_id = this.$store.getters.getRawUserIdForDataTransfer + '-' + this.RPISIssueType + '-' + checked_RPISIssueTypeDetail + '-' + DateTimeHelper.getCurrentDateAndTime();
          return crypto.createSHA256FromString(raw_issue_id);
      },
    resetForm() {
      this.$router.replace("/");
    }
  },
  computed: {
    isFilled: function() {
      if (
        this.whoFilled &&
        this.descriptionFilled &&
        this.commentsFilled &&
        this.issueTypeSelected &&
        this.failureDetailSelected &&
        !this.formDisabled
      ) {
        return false;
      } else {
        return true;
      }
    },
    whoFilled: function() {
      if (
        this.RPISWho.length >= this.whoInputMinLength &&
        this.RPISWho.length <= this.RPISWhoMaxLength
      ) {
        return true;
      }
      return false;
    },
    descriptionFilled: function() {
      if (this.RPISDescription.length >= this.inputMinLength) {
        return true;
      }
      return false;
    },
    commentsFilled: function() {
      if (
          this.RPISComment.length >= this.commentInputMinLength
      ) {
        return true;
      }
      return false;
    },
    issueTypeSelected: function() {
      if (this.selected_issue_type_data !== null) {
        return true;
      } else {
        return false;
      }
    },
    failureDetailSelected: function() {
      if (this.failure_details_list === null) {
        return true;
      }

      if (this.RPISIssueTypeDetail !== null) {
        return true;
      } else {
        return false;
      }
    },
    whoRules() {
      const rules = [];
      if (this.RPISWhoMaxLength) {
        const rule = v =>
          (v || "").length <= this.RPISWhoMaxLength ||
          `A maximum of ${this.RPISWhoMaxLength} characters is allowed`;

        rules.push(rule);
      }
      const min_length_rule = this.minLengthWhoRule;
      rules.push(min_length_rule);
      return rules;
    },
    commentRules() {
      const rules = [];
      const rule = v =>
          (v || '').length >= this.commentInputMinLength ||
          this.$vuetify.lang.t('$vuetify.global.mandatory_field')
      rules.push(rule);
      return rules;
    },
    generalInputRules() {
      const rules = [];
      const min_length_rule = this.minLengthRule;
      rules.push(min_length_rule);
      return rules;
    },
    minLengthRule() {
      return v =>
        (v || "").length >= this.inputMinLength ||
        this.$vuetify.lang.t("$vuetify.global.mandatory_field");
    },
    minLengthWhoRule(){
          return v => (v || '').length >= this.whoInputMinLength || this.$vuetify.lang.t('$vuetify.global.mandatory_field')
    },
  },
  mixins :[appSettings],
  mounted() {
    axios
      .get("resources/static_data/static_process_issue_types.json")
      .then(response => {
        this.build_process_issues_data(response.data);
        this.save_process_issues_data(response.data);
      })
      .catch(() => {
        try {
          this.load_local_process_issue_data();
        } catch (error) {
          window.console.log("Error data not found" + error);
        }
      });
  }
};
</script>